<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <!-- <navbar></navbar> -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- <div class="content">
        <h2>新增</h2>
      </div> -->
    <div class="content" style="padding-bottom: 16px;margin-top: 10px;">
      <p>基础配置</p>
      <el-form :model="pageBasic" :rules="pageRules" ref="pageForm" label-width="150px" class="info-form">
        <el-form-item label="页面标题" prop="title" style="margin-bottom: 20px">
          <el-input style="width: 450px" v-model="pageBasic.title" show-word-limit maxlength="6" placeholder="请输入页面标题"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="页面排序" prop="pageOrder">
          <el-input style="width: 200px" v-model="pageBasic.pageOrder" placeholder="数字越大排位越靠前" show-word-limit
            clearable></el-input>
        </el-form-item>
        <el-form-item label="分享标题" prop="shareTitle" style="margin-bottom: 20px">
          <el-input style="width: 450px" v-model="pageBasic.shareTitle" show-word-limit maxlength="12"
            placeholder="请输入页面标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="分享副标题" prop="shareContent" style="margin-bottom: 20px">
          <el-input style="width: 450px" v-model="pageBasic.shareContent" show-word-limit maxlength="30"
            placeholder="请输入页面标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="分享图片" prop="shareImg">
          <p style="color: #999999">
            建议上传长宽比为1：1的图片，每张上传大小不得超过2M，支持jpg、png格式。
          </p>
          <upload-picture :imgUrl="pageBasic.shareImg" @getUrl="getBasicImg1" />
        </el-form-item>
      </el-form>
    </div>
    <div class="content" style="padding-bottom: 16px">
      <p>页面配置</p>
      <div class="content page-content">
        <div>
          <div class="phone-view">
            <div class="view-title">{{ pageBasic.pageName }}</div>
            <div class="view-content" ref="viewContent" :style="{
              'background-color':
                pageBasic.bgColor && pageBasic.bgType == '2'
                  ? pageBasic.bgColor
                  : '',
              'background-image':
                'url(' +
                (pageBasic.bgImg && pageBasic.bgType == '3'
                  ? pageBasic.bgImg
                  : '') +
                ')',
            }">
              <template v-for="(item, index) in viewData">
                <!-- 图片模块 dff-->
                <div v-if="item.typeFlag == 1" class="view-picture" :ref="'viewModul' + index"
                  :style="{ height: item.imageModelInfo.img ? 'auto' : '' }" @mouseenter="handleShowMask($event, index)"
                  @mouseleave="handleCloseMask($event, index)">
                  <div class="view-picture-mask" :data-idx="index" v-show="item.showViewMask || item.showViewMask2"
                    @click="handleView($event, index, item.typeFlag)"></div>
                  <div class="view-bar" v-show="item.showViewMask || item.showViewMask2">
                    <div class="view-bar-btn" v-if="index > 0" @click="toUp(index)">
                      <img src="../../../assets/icon-down.png" class="icon-down icon-rotate" alt="" />
                      <span>向上</span>
                    </div>
                    <div class="view-bar-btn" v-if="index < viewData.length - 1" @click="toDown(index)">
                      <img src="../../../assets/icon-down.png" class="icon-down" alt="" />
                      <span>向下</span>
                    </div>
                    <div class="view-bar-btn" @click="handleView($event, index, item.typeFlag)">
                      <span>编辑</span>
                    </div>
                    <div class="view-bar-btn" @click="showDeleteView(index, item.typeFlag)">
                      <span>删除</span>
                    </div>
                  </div>
                  <img v-if="item.imageModelInfo.img" :src="item.imageModelInfo.img" class="picture-img" alt="" />
                </div>
                <!-- 商品模块 -->
                <div class="view-picture" v-if="item.typeFlag == 2" :ref="'viewModul' + index" style="height: auto"
                  @mouseenter="handleShowMask($event, index)" @mouseleave="handleCloseMask($event, index)">
                  <div class="view-picture-mask" :data-idx="index" v-show="item.showViewMask || item.showViewMask2"
                    @click="handleView($event, index, item.typeFlag)"></div>
                  <div class="view-bar" v-show="item.showViewMask || item.showViewMask2">
                    <div class="view-bar-btn" @click="toUp(index)" v-if="index > 0">
                      <img src="../../../assets/icon-down.png" class="icon-down icon-rotate" alt="" />
                      <span>向上</span>
                    </div>
                    <div class="view-bar-btn" v-if="index < viewData.length - 1" @click="toDown(index)">
                      <img src="../../../assets/icon-down.png" class="icon-down" alt="" />
                      <span>向下</span>
                    </div>
                    <div class="view-bar-btn" @click="handleView($event, index, item.typeFlag)">
                      <span>编辑</span>
                    </div>
                    <div class="view-bar-btn" @click="showDeleteView(index, item.typeFlag)">
                      <span>删除</span>
                    </div>
                  </div>
                  <div class="tag-menu-box" v-if="item.goodsModelInfo.bindingType == '1'">
                    <div class="tag-menu-item" :class="{ 'tag-menu-active': index == 0 }"
                      v-for="(itemx, index) in item.goodsModelInfo.tagList">
                      {{ itemx.tagName || itemx.name }}
                    </div>
                  </div>
                  <div class="menu-bar" v-if="item.goodsModelInfo.bindingType == '1'">
                    <div class="menu-item">
                      <span>综合</span>
                      <img src="../../../assets/icon_next.png" class="icon-next" alt="" />
                    </div>
                    <div class="menu-item">
                      <span>销量</span>
                      <img src="../../../assets/icon_next.png" class="icon-next" alt="" />
                    </div>
                    <div class="menu-item">
                      <span>价格</span>
                      <img src="../../../assets/icon_next.png" class="icon-next" alt="" />
                    </div>
                    <!-- <div class="menu-item">
                                              <span>佣金</span>
                                              <img src="../../../assets/icon_next.png" class="icon-next" alt="">
                                          </div> -->
                    <div class="menu-item">
                      <img src="../../../assets/icon_shu.png" class="icon-heng" alt="" />
                    </div>
                  </div>

                  <div class="goods-box-two" :class="{
                    'goods-box-two-three':
                      item.goodsModelInfo.layoutType == '1',
                  }">
                    <div style="overflow: hidden" v-if="item.goodsModelInfo.bindingType == '2'">
                      <div class="look-more" v-if="item.goodsModelInfo.moreBtnType == '1'">
                        {{ item.goodsModelInfo.moreName }}
                      </div>
                      <img v-if="item.goodsModelInfo.moreBtnType == '2'" class="btn-img"
                        :src="item.goodsModelInfo.moreImg" alt="" />
                    </div>
                    <!-- thisPOstiin -->
                    <!-- 两列布局 -->
                    <div class="goods-two" v-if="item.goodsModelInfo.layoutType == '2'">
                      <div class="goods-box">
                        <template v-for="(itemx, indexx) in item.goodsModelInfo
                          .goodsList">
                          <div class="goods-info-box" v-if="indexx % 2 == 0">
                            <div class="goods-img-box" :class="{
                              'border-style':
                                item.goodsModelInfo.borderType == '2',
                            }" :style="{
  'border-color': item.goodsModelInfo.borderColor,
}">
                              <img :src="itemx.image || itemx.headImg || itemx.mainImage" class="goods-img" alt="" />
                              <img :src="item.goodsModelInfo.borderImg" v-if="item.goodsModelInfo.borderType == '3'"
                                class="goods-img-border" alt="" />
                            </div>

                            <div class="good-dec">
                              <div class="goods-title">
                                <span class="gift-tips" v-if="itemx.resultType == 1">礼包</span>
                                {{ itemx.name }}
                              </div>
                              <div class="goods-price-box">
                                <p class="goods-price">￥{{ itemx.minPrice || itemx.price }}</p>
                                <p class="goods-saled">
                                  已售{{ itemx.stock || itemx.saleNum }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="goods-box">
                        <template v-for="(itemx, indexx) in item.goodsModelInfo
                          .goodsList">
                          <div class="goods-info-box" v-if="indexx % 2 != 0">
                            <div class="goods-img-box" :style="{
                              'border-color': item.goodsModelInfo.borderColor,
                            }" :class="{
  'border-style':
    item.goodsModelInfo.borderType == '2',
}">
                              <img :src="itemx.image || itemx.headImg || itemx.mainImage" class="goods-img" alt="" />
                              <img :src="item.goodsModelInfo.borderImg" v-if="item.goodsModelInfo.borderType == '3'"
                                class="goods-img-border" alt="" />
                            </div>
                            <div class="good-dec">
                              <div class="goods-title">
                                <span class="gift-tips" v-if="itemx.resultType == 1">礼包</span>
                                {{ itemx.name }}
                              </div>
                              <!-- <div class="goods-tips-box">
                                                                  <div class="goods-tip-item">包邮</div>
                                                                  <div class="goods-tip-item">分享赚钱</div>
                                                              </div> -->
                              <div class="goods-price-box">
                                <p class="goods-price">￥{{ itemx.minPrice || itemx.price }}</p>
                                <p class="goods-saled">
                                  已售{{ itemx.stock || itemx.saleNum }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <!-- 三列布局 -->
                    <div class="goods-three" v-if="item.goodsModelInfo.layoutType == '1'">
                      <div class="three-info-box" v-for="(itemx, indexx) in item.goodsModelInfo.goodsList">
                        <div class="three-img-box" :class="{
                          'border-style':
                            item.goodsModelInfo.borderType == '2',
                        }" :style="{
  'border-color': item.goodsModelInfo.borderColor,
}">
                          <img :src="itemx.image || itemx.mainImage" class="goods-img" alt="" />
                          <img :src="item.goodsModelInfo.borderImg" v-if="item.goodsModelInfo.borderType == '3'"
                            class="goods-img-border" alt="" />
                        </div>
                        <div class="goods-title">
                          <span class="gift-tips" v-if="itemx.resultType == 1">礼包</span>
                          {{ itemx.name }}
                        </div>
                        <div class="goods-price-box" style="margin-top: 0">
                          <p class="goods-price">￥{{ itemx.minPrice || itemx.price }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="bottom-but">
            <el-button type="warning" @click="$router.go(-1)">返回</el-button>
            <el-button type="primary" @click="saveFn">保存</el-button>
          </div>
        </div>
        <div class="settingbox">
          <div>
            <el-button type="primary" plain size="mini" @click="showSettingChange('1')">背景设置</el-button>
            <el-button type="primary" plain size="mini" @click="showSettingChange('2')">添加图片模块</el-button>
            <el-button type="primary" plain size="mini" @click="showSettingChange('3')">添加商品模块</el-button>
          </div>
          <div class="custom" v-show="showSettingBox == '1'">
            <h5 style="margin-bottom: 10px">背景设置</h5>
            <div class="bg-setting">
              <el-form :model="pageBasic" ref="bgFrom">
                <el-form-item label="背景渲染" prop="bgType">
                  <el-radio v-model="pageBasic.bgType" label="1">无背景</el-radio>
                  <el-radio v-model="pageBasic.bgType" label="2">背景颜色</el-radio>
                  <el-radio v-model="pageBasic.bgType" label="3">背景图片</el-radio>
                </el-form-item>
                <el-form-item label="背景颜色" prop="bgColor" v-show="pageBasic.bgType == '2'">
                  <el-color-picker v-model="pageBasic.bgColor"></el-color-picker>
                </el-form-item>
                <el-form-item label="背景图片" prop="bgImg" v-show="pageBasic.bgType == '3'">
                  <upload-picture :imgUrl="pageBasic.bgImg" @getUrl="getBgImage" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="custom" :style="{
            position: 'absolute',
            top: fixTop + 'px',
            'margin-top': 0,
            left: '410px',
          }" v-if="showSettingBox == '2' && viewData.length > 0">
            <h5 style="margin-bottom: 10px">添加图片模块</h5>
            <div class="bg-setting">
              <div style="display: flex">
                <div>
                  <upload-picture :imgUrl="viewData[viewIndex].imageModelInfo.img" @getUrl="getPictureImg" />
                </div>
                <div style="margin-left: 20px">
                  <el-form :model="viewData[viewIndex].imageModelInfo" ref="bgFrom">
                    <el-form-item label="" prop="bindingType">
                      <el-radio v-model="viewData[viewIndex].imageModelInfo.bindingType" label="1">无绑定</el-radio>
                      <el-radio v-model="viewData[viewIndex].imageModelInfo.bindingType" label="2">绑定标签</el-radio>
                      <el-radio v-model="viewData[viewIndex].imageModelInfo.bindingType" label="3">绑定链接</el-radio>
                    </el-form-item>
                    <el-form-item label="标签" prop="" v-show="viewData[viewIndex].imageModelInfo.bindingType == '2'
                      ">
                      <el-button size="mini" type="primary" @click="handleShowTag(1)">选择标签</el-button>
                    </el-form-item>
                    <el-form-item label="已选" prop="" v-show="viewData[viewIndex].imageModelInfo.bindingType == 2 &&
                      viewData[viewIndex].imageModelInfo.tagList &&
                      viewData[viewIndex].imageModelInfo.tagList.length > 0
                      ">
                      <div class="labelbox" style="flex-wrap: wrap">
                        <div class="labelitem" style="margin-bottom: 10px" v-for="(item, index) in viewData[viewIndex]
                          .imageModelInfo.tagList" :key="'dd' + item.id">
                          {{ item.tagName || item.name }}
                          <i class="el-icon-circle-close labelicon" @click="deleteTag(1, index)"></i>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="页面链接" prop="" v-show="viewData[viewIndex].imageModelInfo.bindingType == 3
                      ">
                      <el-input v-model="viewData[viewIndex].imageModelInfo.url"
                        placeholder="如有携带的参数值，请自行一起设置"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
          <div class="custom" :style="{
            position: 'absolute',
            top: fixTop + 'px',
            'margin-top': 0,
            left: '410px',
          }" v-if="showSettingBox == '3' && viewData.length > 0">
            <h5 style="margin-bottom: 10px">添加商品模块</h5>
            <div class="bg-setting">
              <div>
                <div style="margin-left: 20px">
                  <el-form :model="viewData[viewIndex].goodsModelInfo" ref="goodsModelInfo">
                    <el-form-item label="绑定商品" prop="bgType">
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.bindingType" label="1"
                        @change="getTagGoodsChange($event, viewIndex)">绑定标签</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.bindingType" label="2"
                        @change="getTagGoodsChange($event, viewIndex)">选择商品</el-radio>
                    </el-form-item>
                    <el-form-item label="标签" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '1'
                      ">
                      <el-button size="mini" type="primary" @click="handleShowTag(2)">选择标签</el-button>
                    </el-form-item>
                    <el-form-item label="已选" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '1' &&
                      viewData[viewIndex].goodsModelInfo.tagList &&
                      viewData[viewIndex].goodsModelInfo.tagList.length > 0
                      ">
                      <div class="labelbox" style="flex-wrap: wrap">
                        <div class="labelitem" style="margin-bottom: 10px" v-for="(item, index) in viewData[viewIndex]
                          .goodsModelInfo.tagList" :key="'dd' + item.id">
                          {{ item.tagName || item.name }}
                          <i class="el-icon-circle-close labelicon" @click="deleteTag(2, index)"></i>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="按钮设置" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2'
                      ">
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.moreBtnType" label="3">无按钮</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.moreBtnType" label="1">文字名称</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.moreBtnType" label="2">上传图片</el-radio>
                      <div style="margin-left: 70px" v-show="viewData[viewIndex].goodsModelInfo.moreBtnType != '3'
                        ">
                        <el-form-item label="" prop="" v-show="viewData[viewIndex].goodsModelInfo.moreBtnType ==
                          '1'
                          ">
                          <el-input placeholder="按钮文字" size="mini" v-model="viewData[viewIndex].goodsModelInfo.moreName
                            " style="width: 80%"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="" v-show="viewData[viewIndex].goodsModelInfo.moreBtnType ==
                          '2'
                          ">
                          <upload-picture :imgUrl="viewData[viewIndex].goodsModelInfo.moreImg" @getUrl="getmoreImg" />
                        </el-form-item>
                      </div>
                    </el-form-item>
                    <el-form-item label="按钮跳转" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2' &&
                      viewData[viewIndex].goodsModelInfo.moreBtnType != '3'
                      ">
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.moreHrefType
                        " label="1">绑定标签</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.moreHrefType
                        " label="2">绑定链接</el-radio>
                      <div style="margin-left: 70px">
                        <el-form-item label="标签" prop="" v-show="viewData[viewIndex].goodsModelInfo.moreHrefType ==
                          '1'
                          ">
                          <el-button size="mini" type="primary" @click="handleShowTag(3)">选择标签</el-button>
                        </el-form-item>
                        <el-form-item label="已选" prop="" v-show="viewData[viewIndex].goodsModelInfo.moreHrefType ==
                          '1' &&
                          viewData[viewIndex].goodsModelInfo.btnTagList &&
                          viewData[viewIndex].goodsModelInfo.btnTagList
                            .length > 0
                          ">
                          <div class="labelbox" style="flex-wrap: wrap">
                            <div class="labelitem" style="margin-bottom: 10px" v-for="(item, index) in viewData[viewIndex]
                              .goodsModelInfo.btnTagList" :key="'dd' + item.id">
                              {{ item.tagName }}
                              <i class="el-icon-circle-close labelicon" @click="deleteTag(3, index)"></i>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </el-form-item>
                    <el-form-item label="页面链接" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2' &&
                      viewData[viewIndex].goodsModelInfo.moreHrefType ==
                      '2' &&
                      viewData[viewIndex].goodsModelInfo.moreBtnType != '3'
                      ">
                      <el-input placeholder="如有携带的参数值，请自行一起设置" size="mini"
                        v-model="viewData[viewIndex].goodsModelInfo.moreUrl" style="width: 80%"></el-input>
                    </el-form-item>
                    <el-form-item label="添加商品" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2'
                      ">
                      <el-button size="mini" type="primary" @click="showGoodsDialog = true">添加</el-button>
                    </el-form-item>
                    <el-form-item label="布局方式" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2'
                      ">
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.layoutType" label="1">三图平铺</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.layoutType" label="2">双图排列</el-radio>
                    </el-form-item>
                    <el-form-item label="边框渲染" prop="" v-show="viewData[viewIndex].goodsModelInfo.bindingType == '2'
                      ">
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.borderType" label="1">无边框</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.borderType" label="2">边框颜色</el-radio>
                      <el-radio v-model="viewData[viewIndex].goodsModelInfo.borderType" label="3">边框图片</el-radio>
                      <div style="margin-left: 70px">
                        <el-form-item label="" prop="" v-show="viewData[viewIndex].goodsModelInfo.borderType == '2'
                          ">
                          <el-color-picker v-model="viewData[viewIndex].goodsModelInfo.borderColor
                            "></el-color-picker>
                        </el-form-item>
                        <el-form-item label="" prop="" v-show="viewData[viewIndex].goodsModelInfo.borderType == '3'
                          ">
                          <upload-picture :imgUrl="viewData[viewIndex].goodsModelInfo.borderImg
                            " @getUrl="getborderImg" />
                        </el-form-item>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择标签" style="padding: 0 20px" :visible.sync="showTagDialog" width="1080px" append-to-body
      @close="closeFn">
      <div class="tag—table-box">
        <el-form ref="tagForm" :model="searchTag" :inline="true" id="search" size="small">
          <el-form-item label="标签" prop="name">
            <el-input v-model="searchTag.name" clearable placeholder="标签名称"></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="categoryFirst">
            <el-select v-model="searchTag.categoryFirst" placeholder="" clearable>
              <el-option v-for="item in dictionaries.goods_tag_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类目" prop="categorySecond">
            <el-select v-model="searchTag.categorySecond" placeholder="" clearable>
              <el-option v-for="item in dictionaries.goods_tag_class" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="primary-mini" @click="fetchTagData('search')">查询</div>
            <div class="primary-mini" @click="fetchTagData('reset')">重置</div>
            <!-- <el-button type="primary" @click="fetchTagData('search')">查询</el-button>
                          <el-button type="primary" plain @click="fetchTagData('reset')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 20px">
          <div class="primary-plain" @click="batchSelectTag(1)">批量选择</div>
          <div class="primary-plain" @click="batchSelectTag(2)">批量取消</div>
          <!-- <el-button type="primary" size="mini" plain @click="batchSelectTag(1)">批量选择</el-button>
                      <el-button type="primary" size="mini" plain @click="batchSelectTag(2)">批量取消</el-button> -->
        </div>
        <el-table :data="tagList" style="width: 100%" ref="labelTable"
          :header-cell-style="{ background: '#F8F8F8', color: '#333333' }" @selection-change="handleSelectionChange"
          :cell-style="{ padding: '0' }">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="标签" prop="name"></el-table-column>
          <el-table-column label="排序" prop="sort"></el-table-column>
          <el-table-column label="标签分类" prop="categoryFirstLabel"></el-table-column>
          <el-table-column label="标签类目" prop="categorySecondLabel"></el-table-column>
          <el-table-column label="是否对外展示" prop="">
            <template slot-scope="scope">
              <p>{{ scope.row.isShow == 1 ? "是" : "否" }}</p>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="tagName">
            <template slot-scope="scope">
              <div class="tag-status">
                <div class="circle" :style="{
                  'background-color':
                    scope.row.status == 1 ? '#67c23a' : 'red',
                }"></div>
                <span>{{ scope.row.status == 1 ? '启用中' : '禁用' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template slot-scope="scope">
              <el-button type="text" v-if="!scope.row.selected" @click="handleSelectTag(scope)">选择</el-button>
              <el-button type="text" style="color: red" v-if="scope.row.selected"
                @click="handleSelectTag(scope)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="
              margin-bottom: 20px;
              background-color: #f8f8f8;
              overflow: hidden;
            ">
          <div style="float: right">
            <el-pagination v-if="tagList.length > 0" background @size-change="onSizeChange"
              @current-change="onCurrentChange" :current-page="labelPageNo" :page-sizes="[5, 10, 20]"
              :page-size="labelPageSize" layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="primary-gray" @click="closeTagDialog($event, 1)">取 消</div>
        <div class="primary-button" @click="closeTagDialog($event, 2)">
          确 定
        </div>
        <!-- <el-button @click="showTagDialog = false">取 消</el-button>
                  <el-button type="primary" @click="closeTagDialog">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="添加商品" :visible.sync="showGoodsDialog" width="1010px" append-to-body>
      <div class="tag—table-box" v-if="viewData.length > 0 && viewData[viewIndex].goodsModelInfo">
        <el-form ref="searchGoods" :model="searchGoods" :inline="true" size="small">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="searchGoods.name" clearable placeholder="商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品标签/类别" prop="tagOrCategory">
            <el-input v-model="searchGoods.tagOrCategory" clearable placeholder="商品标签/类别"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="primary-mini" @click="fetchGoodsData('search')">
              查询
            </div>
            <div class="primary-mini" @click="fetchGoodsData('reset')">
              重置
            </div>
            <!-- <el-button type="primary" @click="fetchGoodsData('search')">查询</el-button>
                          <el-button type="primary" plain @click="fetchGoodsData('reset')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 20px">
          <span style="font-weight: bold">选择商品：</span>
          <div class="primary-plain" @click="batchSelectGoods(1)">批量选择</div>
          <!-- <el-button type="primary" size="mini" plain @click="batchSelectGoods(1)">批量选择</el-button> -->
        </div>
        <el-table :data="goodsList" style="width: 100%" ref="goodsTable"
          :header-cell-style="{ background: '#F8F8F8', color: '#333333' }" @selection-change="handleSelectionGoodsChange"
          :cell-style="{ padding: '10px' }">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="商品ID" prop="id"></el-table-column>
          <el-table-column label="商品名称" prop="name">
            <template slot-scope="scope">
              <p class="goods-name">{{ scope.row.name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="商品图片" prop="image">
            <template slot-scope="scope">
              <img class="table-goods-img" :src="scope.row.image" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="商品状态" prop="tagName">
            <template slot-scope="scope">
              <div class="tag-status">
                <div class="circle" :style="{
                  'background-color':
                    scope.row.statusLabel.indexOf('上架') > -1
                      ? '#67c23a'
                      : 'red',
                }"></div>
                <span>{{ scope.row.statusLabel }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSelectGoods(scope, 1)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="
              margin-bottom: 20px;
              background-color: #f8f8f8;
              overflow: hidden;
            ">
          <div style="float: right">
            <el-pagination v-if="tagList.length > 0" background @size-change="onGoodsSizeChange"
              @current-change="onGoodsCurrentChange" :current-page="goodsPageNo" :page-sizes="[5, 10, 20]"
              :page-size="goodsPageSize" layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
            </el-pagination>
          </div>
        </div>
        <div style="margin-bottom: 20px">
          <span style="font-weight: bold">已选商品：</span>
          <div class="primary-plain" @click="batchSelectGoods(2)">批量取消</div>
          <!-- <el-button type="primary" size="mini" plain @click="batchSelectGoods(2)">批量取消</el-button> -->
        </div>
        <el-table :data="viewData[viewIndex].goodsModelInfo.selectedGoodsList" style="width: 100%"
          :header-cell-style="{ background: '#F8F8F8', color: '#333333' }"
          @selection-change="handleSelectionGoodsCancelChange" :cell-style="{ padding: '10px' }">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="商品ID" prop="id"></el-table-column>
          <el-table-column label="商品名称" prop="name">
            <template slot-scope="scope">
              <p class="goods-name">{{ scope.row.name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="商品图片" prop="typeFlagLabel">
            <template slot-scope="scope">
              <img class="table-goods-img" :src="scope.row.image || scope.row.image" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="商品状态" prop="tagName">
            <template slot-scope="scope">
              <div class="tag-status">
                <div class="circle" :style="{
                  'background-color':
                    scope.row.statusLabel.indexOf('上架') > -1
                      ? '#67c23a'
                      : 'red',
                }"></div>
                <span>{{ scope.row.statusLabel }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template slot-scope="scope">
              <el-button type="text" style="color: red" @click="handleSelectGoods(scope, 2)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="primary-gray" @click="
          showGoodsDialog = false;
        $refs.goodsTable.clearSelection();
        ">
          取 消
        </div>
        <div class="primary-button" @click="showGoodsDialog = false">确 定</div>
        <!-- <el-button @click="showGoodsDialog = false">取 消</el-button>
                  <el-button type="primary" @click="showGoodsDialog = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="dialogVisible" width="600px">
      <div slot="title">
        <i class="el-icon-warning" style="color: red"></i>
        删除提示
      </div>
      <div>删除后已设置内容将无法恢复，是否继续？</div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteViewFn()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import navbar from '@/components/navbar.vue'
import uploadPicture from './components/custom-picture.vue'
import breadcrumbTop from '../../../components/breadcrumb.vue'
// import common from './mixins/common'
export default {
  // mixins: [common],
  components: { navbar, uploadPicture, breadcrumbTop },
  data() {
    return {
      dataList: {
        list: [
          { title: 'APP设置', path: '', type: '0' },
          { title: '新增/编辑页面', path: '', type: '1' }
        ]
      },
      pageBasic: {
        title: '',//页面标题
        enterType: '',//页面入口选择
        img: '',//入口图
        pageOrder: '',//页面顺序
        bgType: '1',//背景设置：1无背景，2背景颜色，3背景图片
        bgImg: '',//背景图片
        bgColor: '',//背景颜色
        shareTitle: '',//分享标题
        shareContent: '',//分享副标题
        shareImg: '',//分享图片
      },
      pageRules: {
        title: [
          { required: true, message: '请输入页面标题', trigger: 'blur' }
        ],
        enterType: [
          { required: true, message: '请选择页面入口', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传入口图', trigger: 'blur' }
        ],
        pageOrder: [
          { required: true, message: '请输入页面顺序', trigger: 'blur' }
        ],
        shareTitle: [
          { required: true, message: '请输入分享标题', trigger: 'blur' }
        ],
        shareContent: [
          { required: true, message: '请输入分享副标题', trigger: 'blur' }
        ],
        shareImg: [
          { required: true, message: '请上传分享图片', trigger: 'blur' }
        ],
      },
      insertList: [
        { name: '导航栏', id: 1 }
      ],
      bgForm: {
        bgType: '1',//背景设置：1无背景，2背景颜色，3背景图片
        bgColor: '',//背景颜色
        bgImage: ''//背景图片
      },
      showBgSetting: false,
      showPictureSetting: false,
      imageModelInfo: {//图片模块
        image: '',//图片
        bindType: '1',//有无绑定 1无绑定，2绑定标签，3绑定链接
        tagList: [],//绑定的标签
        url: '',//绑定的链接
      },
      labelPageNo: 1,
      labelPageSize: 10,
      labelTotalNum: 0,
      tagList: [],
      goodsPageNo: 1,
      goodsPageSize: 5,
      goodsList: [],
      goodsTotalNum: 0,
      showTagDialog: false,
      tagForm: {
        tagName: '',
        typeFlag: ''
      },
      goodsModelInfo: {
        bindType: '1',//绑定商品设置：绑定标签1，选择商品2
        moreBtnType: '1',//按钮设置：文字名称1，上传图片2
        moreHrefType: '1',//按钮跳转设置：绑定标签1，绑定链接2
        layoutType: '2',//布局方式：三图平铺1,双图排列2
        borderType: '1',//边框渲染：1无边框，2边框颜色，3边框图片
      },
      seletedTag: [
        { tagName: '礼包', id: 1 },
        { tagName: '礼包礼包礼包', id: 2 },
        { tagName: '礼包礼包礼包', id: 3 },
        { tagName: '礼包礼包', id: 4 },
        { tagName: '礼包', id: 5 }
      ],
      showSettingBox: '',//1背景设置，2添加图片模块，3添加商品模块
      viewData: [],//自定义布局数组
      showViewMask: false,//控制显示浮层
      showViewMask2: false,
      pageY: 0,
      viewIndex: 0,
      showTagType: 0,//从哪里打开选择标签表格的，1为添加图片模块的绑定标签，2为绑定商品模块的，3为绑定按钮的
      tagSelectionList: [],//多选的标签列表
      goodsSelectionList: [],//多选的选择商品列表
      goodsSelectionList2: [],//多选的取消商品列表
      dialogVisible: false,
      delIndex: 0,
      showGoodsDialog: false,
      fixTop: 0,
      searchTag: {
        name: '',
        categoryFirst: '',
        categorySecond: ''
      },
      searchGoods: {
        name: '',
        tagOrCategory: ''
      },
      pid: null,
      dictionaries: [],
      canClick: true
    }
  },
  created() {

    let pid = this.$route.query.id || null;
    this.pid = pid;
    this.getDictionaries('goods_tag_type')
    this.getDictionaries('goods_tag_class')
    this.getGoodsList()//获取商品数据
    this.getTagList()//获取标签表格数据
    if (this.pid) {
      this.getDetail()
    }

  },
  methods: {
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/getDictGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    getDetail() {
      this.$api.getPageDetail({ id: this.pid })
        .then(res => {
          if (res.code == 0) {
            res.data.enterType = res.data.enterType + '';
            res.data.bgType = res.data.bgType + '';
            Object.assign(this.pageBasic, res.data)
            if (!res.data.shareTitle) {
              this.pageBasic.shareTitle = res.data.title
            }
            if (!res.data.shareImg) {
              this.pageBasic.shareImg = res.data.img
            }
            let arr = res.data.modelList;
            arr.forEach(async item => {
              item.showViewMask = false;
              item.showViewMask2 = false;
              item.typeFlag = item.typeFlag + '';
              if (item.typeFlag == '2') {
                //         bindType: '1',//绑定商品设置：绑定标签1，选择商品2
                // moreBtnType: '1',//按钮设置：文字名称1，上传图片2
                // moreHrefType: '1',//按钮跳转设置：绑定标签1，绑定链接2
                // layoutType: '2',//布局方式：三图平铺1,双图排列2
                // borderType: '1',//边框渲染：1无边框，2边框颜色，3边框图片
                console.log('灌灌灌灌==', item.goodsModelInfo.bindingType)
                item.goodsModelInfo.bindingType = item.goodsModelInfo.bindingType + '';
                item.goodsModelInfo.borderType = item.goodsModelInfo.borderType + '';
                item.goodsModelInfo.layoutType = item.goodsModelInfo.layoutType + '';
                item.goodsModelInfo.moreBtnType = item.goodsModelInfo.moreBtnType + '';
                item.goodsModelInfo.moreHrefType = item.goodsModelInfo.moreHrefType + '';
                if (item.goodsModelInfo.bindingType == '1') {
                  if (item.goodsModelInfo.goodsTagList && item.goodsModelInfo.goodsTagList.length > 0) {

                    item.goodsModelInfo.tagList = item.goodsModelInfo.goodsTagList.map(el => {
                      return {
                        id: el.id,
                        tagName: el.name
                      }
                    })
                    let arr1 = item.goodsModelInfo.tagList.map(item => {
                      return item.id
                    })
                    let list = await this.getEnableTags(arr1)
                    list.forEach(val => {
                      val.tagName = val.name
                    })
                    item.goodsModelInfo.tagList = list
                    item.goodsModelInfo.goodsList = await this.searchGoodsList([list[0].id])
                    item.goodsModelInfo.goodsList.forEach(it => {
                      it.selected = true
                    })
                  } else {
                    item.goodsModelInfo.goodsList = []
                    item.goodsModelInfo.tagList = []
                  }
                } else {

                  if (item.goodsModelInfo.moreBtnType == '1') {
                    if (item.goodsModelInfo.moreGoodsTagList && item.goodsModelInfo.moreGoodsTagList.length > 0) {
                      item.goodsModelInfo.btnTagList = item.goodsModelInfo.moreGoodsTagList.map(el => {
                        return {
                          id: el.id,
                          tagName: el.name
                        }
                      })
                    } else {
                      item.goodsModelInfo.btnTagList = []
                    }
                  }

                  if (item.goodsModelInfo.goodsNos) {
                    item.goodsModelInfo.goodsNos = item.goodsModelInfo.goodsNos.split(',')
                    item.goodsModelInfo.goodsList = await this.getSelectGoodsList(item.goodsModelInfo.goodsNos)
                    console.log('商品===', item.goodsModelInfo.goodsList)
                    item.goodsModelInfo.goodsList.forEach(it => {
                      it.selected = true
                    })
                    item.goodsModelInfo.selectedGoodsList = item.goodsModelInfo.goodsList;
                  }
                }


              } else {
                item.imageModelInfo.bindingType = item.imageModelInfo.bindingType + '';

                if (item.imageModelInfo.bindingType == '2') {
                  console.log(4444)
                  if (item.imageModelInfo.goodsTagList) {
                    item.imageModelInfo.tagList = item.imageModelInfo.goodsTagList.map(el => {
                      return {
                        id: el.id,
                        tagName: el.name
                      }
                    })
                    let arr1 = item.imageModelInfo.tagList.map(val => {
                      return val.id
                    })
                    let list = await this.getEnableTags(arr1)
                    list.forEach(val => {
                      val.tagName = val.name
                    })
                    item.imageModelInfo.tagList = list;
                  } else {
                    item.imageModelInfo.tagList = []
                  }

                }

              }
            })
            let timer = setTimeout(() => {
              this.viewData = arr;
            }, 1000)

            console.log(arr)
          }
          this.$forceUpdate()
          // Object.assign(this.ruleForm, res.data)
        })
    },
    async getEnableTags(ids) {
      let res = await this.axios.get('/appIndex/getEnableTags?tagIds=' + ids)
      console.log('过滤标签==', res)
      if (res.code == 0) {
        return res.data
      } else {
        return []
      }
    },
    async getSelectGoodsList(arr) {
      console.log(arr)
      let data = {
        goodsNos: arr
      }
      let res = await this.axios.post('/goods/findGoodsByGoodsNos', data)
      console.log(res)
      if (res.code == 0) {
        return res.data
      }
      // let res = await this.$api.getSelectGoodsList(data)
      // return res.data

    },

    saveFn() {
      console.log(this.canClick)
      // return
      if (!this.canClick) {
        this.$message.warning('请稍后保存！')
        return
      } //防抖节流
      if (this.pageBasic.title == '') {
        this.$message.warning('请输入页面标题')
        return
      }
      // if (this.pageBasic.enterType == '') {
      //   this.$message.warning('请选择页面入口')
      //   return
      // }
      // if (this.pageBasic.img == '') {
      //   this.$message.warning('请上传入口图片')
      //   return
      // }
      if (this.pageBasic.shareTitle == '') {
        this.$message.warning('请输入分享标题')
        return
      }
      if (this.pageBasic.shareContent == '') {
        this.$message.warning('请输入分享副标题')
        return
      }
      if (this.pageBasic.shareImg == '') {
        this.$message.warning('请上传分享图片')
        return
      }
      let viewData = JSON.parse(JSON.stringify(this.viewData))
      viewData.forEach(async (item, index) => {
        if (item.typeFlag == 1) {//图片模块
          if (item.imageModelInfo.bindingType == '2') {
            let arr = item.imageModelInfo.tagList.map(el => {
              return el.id
            })
            item.imageModelInfo.goodsTagIds = arr.join(',')
            delete item.imageModelInfo.tagList
          }
        } else {//商品模块
          if (item.goodsModelInfo.bindingType == '1') {
            let ids = item.goodsModelInfo.tagList.map(item => {
              return item.id
            })
            item.goodsModelInfo.tagList = await this.getEnableTags(ids)
            item.goodsModelInfo.goodsTagList = item.goodsModelInfo.tagList
            let arr = item.goodsModelInfo.tagList.map(el => {
              return el.id
            })
            item.goodsModelInfo.goodsTagIds = arr.join(',')
            // item.goodsModelInfo.moreGoodsTagIds = ''
            // item.goodsModelInfo.goodsNos = ''
          } else {

          }
          if (item.goodsModelInfo) {
            if (item.goodsModelInfo.btnTagList && item.goodsModelInfo.btnTagList.length > 0) {
              let arr = item.goodsModelInfo.btnTagList.map(el => {
                return el.id
              })
              item.goodsModelInfo.moreGoodsTagIds = arr.join(',')
            } else {
              item.goodsModelInfo.moreGoodsTagIds = ''
            }
            if (item.goodsModelInfo.goodsList && item.goodsModelInfo.goodsList.length > 0) {
              let arr1 = item.goodsModelInfo.goodsList.map(el => {
                return el.goodsNo
              })
              viewData[index].goodsModelInfo.goodsNos = arr1.join(',')
              console.log('桑普编号', item.goodsModelInfo.goodsNos)
            }
            let ids = item.goodsModelInfo.tagList.map(item => {
              return item.id
            })
            // console.log('typeof item.goodsModelInfo.goodsNos==',typeof item.goodsModelInfo.goodsNos)
            // if(typeof item.goodsModelInfo.goodsNos != 'string'){

            //   item.goodsModelInfo.goodsNos = item.goodsModelInfo.goodsNos.join(',')
            // }
            item.goodsModelInfo.goodsTagIds = ids.join(',')
            item.goodsModelInfo.tagList = await this.getEnableTags(ids)
            item.goodsModelInfo.goodsTagList = item.goodsModelInfo.tagList
          }
          delete item.goodsModelInfo.tagList
          delete item.goodsModelInfo.btnTagList
          delete item.goodsModelInfo.goodsList

        }
        delete item.showViewMask
        delete item.showViewMask2
      })
      // return
      let pageBasic = JSON.parse(JSON.stringify(this.pageBasic))
      if (pageBasic.bgType == '1') {
        pageBasic.bgImg = '';
        pageBasic.bgColor = '';
      } else if (pageBasic.bgType == '2') {
        pageBasic.bgImg = '';
      } else {
        pageBasic.bgColor = '';
      }
      pageBasic.modelList = [];
      console.log(viewData)
      // return
      viewData.map((item, index) => {
        if (item.goodsModelInfo) {
          if (item.goodsModelInfo.tagList && item.goodsModelInfo.tagList.length > 0) {
            viewData[index].goodsModelInfo.goodsTagList = item.goodsModelInfo.tagList
            let ids = item.goodsModelInfo.tagList.map(item => {
              return item.id
            })
            viewData[index].goodsModelInfo.goodsTagIds = ids.join(',')
          }
          if (item.goodsModelInfo.goodsList && item.goodsModelInfo.goodsList.length > 0) {
            let arr1 = item.goodsModelInfo.goodsList.map(el => {
              return el.goodsNo
            })
            viewData[index].goodsModelInfo.goodsNos = arr1.join(',')
            console.log('桑普编号', item.goodsModelInfo.goodsNos)
          }
          console.log('标签是是是==', typeof item.goodsModelInfo.goodsNos)
          if (typeof item.goodsModelInfo.goodsNos == 'object') {
            viewData[index].goodsModelInfo.goodsNos = item.goodsModelInfo.goodsNos.join(',')
          }
        }
      })
      pageBasic.modelList = viewData;
      console.log(pageBasic)
      // saveData.modelList = viewData
      // return
      this.canClick = false
      let timer = setTimeout(() => {
        console.log('定时器', this.canClick)
        this.canClick = true
      }, 1000)
      this.$api.savePage(pageBasic).then(res => {
        console.log(res)


        if (res.code == 0) {

          this.$router.go(-1)

        }
      })
    },
    //切换添加商品模块绑定标签还是选择商品
    async getTagGoodsChange(e, idx) {
      console.log(e, idx)
      if (e == '1') {
        if (this.viewData[this.viewIndex].goodsModelInfo.tagList) {
          let arr = this.viewData[this.viewIndex].goodsModelInfo.tagList.map(item => {
            return item.id
          })
          if (arr.length == 0) return
          this.viewData[this.viewIndex].goodsModelInfo.goodsList = await this.searchGoodsList(arr)
        }

      } else {
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = this.viewData[this.viewIndex].goodsModelInfo.selectedGoodsList || [];
      }
      this.$forceUpdate()
    },
    async closeTagDialog(e, idx) {
      this.showTagDialog = false;
      console.log('发鬼地方个', idx)

      if (idx == 2) {
        if (this.showSettingBox == '3' && this.viewData[this.viewIndex].goodsModelInfo.bindingType == '1') {

          let arr = this.viewData[this.viewIndex].goodsModelInfo.tagList.map(item => {
            return item.id
          })

          if (arr.length > 0) {
            this.viewData[this.viewIndex].goodsModelInfo.goodsList = await this.searchGoodsList(arr)
          }

        }
      }
      console.log('蘑菇', this.viewData[this.viewIndex])
      this.$refs.labelTable.clearSelection()
      console.log(this.viewData)
    },
    //获取标签商品
    async searchGoodsList(arr) {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        tagIds: arr,
        orderBy: 0
      }
      let res = await this.$api.searchGoods(data)
      console.log(res)
      if (res.code == 0) {
        if (res.data.list.length > 0) {
          let list = res.data.list
          return list
        }
      }
    },
    toDown(idx) {
      let array = this.viewData;
      this.showSettingBox = ''
      array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
      this.$forceUpdate()
    },
    toUp(idx) {
      let array = this.viewData;
      this.showSettingBox = ''
      array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
      this.$forceUpdate()
    },
    deleteViewFn() {
      this.dialogVisible = false;
      this.viewIndex = 0;
      // console.log(this.showSettingBox)
      this.viewData.splice(this.delIndex, 1)
      // if (this.delIndex == 0) {
      //     this.viewIndex = 0;
      // } else {
      //     this.viewIndex = this.delIndex - 1;
      // }


      this.$forceUpdate()
    },
    showDeleteView(idx, typeFlag) {
      // console.log(idx)
      this.dialogVisible = true;
      this.delIndex = idx;
      this.viewIndex = idx;
      this.showSettingBox = ''//typeFlag == 1 ? '2' : '3';
    },
    //批量选择、批量取消标签
    batchSelectTag(type) {
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            tagName: i.name
          }
        }
      })
      //showTagType == 1为图片模块的，2为绑定商品模块的，3为绑定按钮的
      if (this.showTagType == 1) { //1是图片模块的标签
        this.viewData[this.viewIndex].imageModelInfo.tagList = arr;
      } else if (this.showTagType == 2) {
        this.viewData[this.viewIndex].goodsModelInfo.tagList = arr;
      } else {
        this.viewData[this.viewIndex].goodsModelInfo.btnTagList = arr;
      }
      this.$forceUpdate()
    },
    //标签多选
    handleSelectionChange(val) {
      this.tagSelectionList = val;
    },
    //选择商品多选
    handleSelectionGoodsChange(val) {
      this.goodsSelectionList = val;
    },
    //取消商品多选
    handleSelectionGoodsCancelChange(val) {
      this.goodsSelectionList2 = val;
    },
    handleShowTag(e) {
      this.showTagDialog = true;
      this.showTagType = e;//1为图片模块的，2为绑定商品模块的，3为绑定按钮的
      this.tagList.forEach((item, index) => {
        item.selected = false;
      })
      //1为添加图片模块的绑定标签
      if (e == 1) {
        // console.log('this.viewIndex=', this.viewIndex)
        this.tagList.forEach((item, index) => {
          if (this.viewData[this.viewIndex].imageModelInfo.tagList) {
            this.viewData[this.viewIndex].imageModelInfo.tagList.forEach((v, i) => {
              if (item.id == v.id) {
                item.selected = true;
              }
            })
          }

        })
      } else if (e == 2) {
        this.tagList.forEach((item, index) => {
          if (this.viewData[this.viewIndex].goodsModelInfo.tagList) {

            this.viewData[this.viewIndex].goodsModelInfo.tagList.forEach((v, i) => {
              if (item.id == v.id) {
                item.selected = true;
              }
            })
          }
        })
      } else {
        this.tagList.forEach((item, index) => {
          if (this.viewData[this.viewIndex].goodsModelInfo.btnTagList) {

            this.viewData[this.viewIndex].goodsModelInfo.btnTagList.forEach((v, i) => {
              if (item.id == v.id) {
                item.selected = true;
              }
            })
          }
        })
      }
      this.$forceUpdate()
    },
    //删除标签
    async deleteTag(type, idx) {
      //type == 1 删除图片模块标签、2删除商品模块标签、3删除按钮模块标签
      if (type == 1) {
        this.viewData[this.viewIndex].imageModelInfo.tagList.splice(idx, 1)
      } else if (type == 2) {
        this.viewData[this.viewIndex].goodsModelInfo.tagList.splice(idx, 1)
        let arr = this.viewData[this.viewIndex].goodsModelInfo.tagList.map(item => {
          return item.id
        })
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = await this.searchGoodsList(arr)
      } else {
        this.viewData[this.viewIndex].goodsModelInfo.btnTagList.splice(idx, 1)
      }
      this.tagList.forEach((item, index) => {
        if (type == 1) {
          this.viewData[this.viewIndex].imageModelInfo.tagList.forEach((v, i) => {
            if (item.id == v.id) {
              item.selected = true;
            }
          })
        } else if (type == 2) {
          this.viewData[this.viewIndex].goodsModelInfo.tagList.forEach((v, i) => {
            if (item.id == v.id) {
              item.selected = true;
            }
          })
        } else {
          this.viewData[this.viewIndex].goodsModelInfo.btnTagList.forEach((v, i) => {
            if (item.id == v.id) {
              item.selected = true;
            }
          })
        }
      })
      console.log(this.viewData[this.viewIndex].goodsModelInfo.btnTagList)
    },
    //选择标签
    async handleSelectTag(scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      //showTagType == 1为图片模块的，2为绑定商品模块的，3为绑定按钮的
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          tagName: scope.row.name
        };
        let list = await this.getEnableTags([scope.row.id])
        if (list.length == 0) return
        this.tagList[scope.$index].selected = true;
        console.log(this.viewData[this.viewIndex].imageModelInfo)
        if (this.showTagType == 1) {
          if (!this.viewData[this.viewIndex].imageModelInfo.tagList) {
            this.viewData[this.viewIndex].imageModelInfo.tagList = []
          }
          this.viewData[this.viewIndex].imageModelInfo.tagList.push(data)
        } else if (this.showTagType == 2) {
          if (!this.viewData[this.viewIndex].goodsModelInfo.tagList) {
            this.viewData[this.viewIndex].goodsModelInfo.tagList = []
          }
          this.viewData[this.viewIndex].goodsModelInfo.tagList.push(data)
          let arr = this.viewData[this.viewIndex].goodsModelInfo.tagList.map(item => {
            return item.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.tagList = await this.getEnableTags(arr)
          this.viewData[this.viewIndex].goodsModelInfo.goodsTagList = this.viewData[this.viewIndex].goodsModelInfo.tagList
          let tagIds = this.viewData[this.viewIndex].goodsModelInfo.goodsTagList.map(val => {
            return val.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.goodsTagIds = tagIds.join(',')
        } else {
          if (!this.viewData[this.viewIndex].goodsModelInfo.btnTagList) {
            this.viewData[this.viewIndex].goodsModelInfo.btnTagList = []
          }
          this.viewData[this.viewIndex].goodsModelInfo.btnTagList.push(data)
        }

      } else {
        this.tagList[scope.$index].selected = false;
        if (this.showTagType == 1) {
          let idx = this.viewData[this.viewIndex].imageModelInfo.tagList.findIndex(item => {
            return item.id == scope.row.id
          })
          this.viewData[this.viewIndex].imageModelInfo.tagList.splice(idx, 1)

        } else if (this.showTagType == 2) {
          let idx = this.viewData[this.viewIndex].goodsModelInfo.tagList.findIndex(item => {
            return item.id == scope.row.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.tagList.splice(idx, 1)
          let arr = this.viewData[this.viewIndex].goodsModelInfo.tagList.map(item => {
            return item.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.tagList = await this.getEnableTags(arr)
          this.viewData[this.viewIndex].goodsModelInfo.goodsTagList = this.viewData[this.viewIndex].goodsModelInfo.tagList
          let tagIds = this.viewData[this.viewIndex].goodsModelInfo.goodsTagList.map(val => {
            return val.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.goodsTagIds = tagIds.join(',')
        } else {
          let idx = this.viewData[this.viewIndex].goodsModelInfo.btnTagList.findIndex(item => {
            return item.id == scope.row.id
          })
          this.viewData[this.viewIndex].goodsModelInfo.btnTagList.splice(idx, 1)
        }

      }

      this.$forceUpdate()
    },
    //选择商品
    handleSelectGoods(scope, type) {
      //type==1为选择商品，2为取消商品
      if (type == 1) {
        this.viewData[this.viewIndex].goodsModelInfo.goodsList.push(scope.row)
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = this.arrDistinctByProp(this.viewData[this.viewIndex].goodsModelInfo.goodsList, 'id')
        this.viewData[this.viewIndex].goodsModelInfo.goodsList.forEach(item => {
          item.selected = true;
        })
      } else {
        this.viewData[this.viewIndex].goodsModelInfo.goodsList[scope.$index].selected = false
        let arr = this.viewData[this.viewIndex].goodsModelInfo.goodsList.filter(item => {
          return item.selected
        })
        // console.log(this.viewData[this.viewIndex].goodsModelInfo)
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = arr;
      }
      this.viewData[this.viewIndex].goodsModelInfo.selectedGoodsList = this.viewData[this.viewIndex].goodsModelInfo.goodsList;
      this.$forceUpdate()

      console.log(scope)
    },
    //批量选择、取消商品
    batchSelectGoods(type) {
      console.log('商品', type)
      if (type == 1) {
        console.log(this.viewData[this.viewIndex].goodsModelInfo.goodsList)
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = this.viewData[this.viewIndex].goodsModelInfo.goodsList.concat(this.goodsSelectionList)
        // this.viewData[this.viewIndex].goodsModelInfo.goodsList = this.arrDistinctByProp(this.viewData[this.viewIndex].goodsModelInfo.goodsList,'id')
        this.viewData[this.viewIndex].goodsModelInfo.goodsList.forEach(item => {
          item.selected = true;
        })
      } else {
        this.goodsSelectionList2.forEach(item => {
          item.selected = false
        })
        let arr = this.viewData[this.viewIndex].goodsModelInfo.goodsList.filter(item => {
          return item.selected
        })
        this.viewData[this.viewIndex].goodsModelInfo.goodsList = arr;
      }
      this.viewData[this.viewIndex].goodsModelInfo.selectedGoodsList = this.viewData[this.viewIndex].goodsModelInfo.goodsList;
    },
    handleCloseMask(e, idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showViewMask = false;
        }
      })
    },
    handleShowMask(e, idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showViewMask = true;
        } else {
          item.showViewMask = false;
        }

      })
    },
    //点击模块
    handleView(e, idx, typeFlag) {
      console.log(333)
      console.log(e)
      // this.pageY = e.screenY
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showViewMask = true;
          item.showViewMask2 = true;
        } else {
          item.showViewMask = false;
          item.showViewMask2 = false;
        }

      })
      // console.log(idx, this.viewData)
      this.viewIndex = idx;
      this.showSettingBox = typeFlag == 1 ? '2' : '3';
      // console.log(this.viewData[this.viewIndex].imageModelInfo.linkUrl, this.viewIndex)
      setTimeout(() => {
        let v = this.$refs['viewModul' + idx]
        let c = this.$refs['viewContent']
        console.log(c.scrollTop)
        if (c.scrollTop > 0) {
          this.fixTop = v[0].offsetTop - c.scrollTop
        } else {
          this.fixTop = v[0].offsetTop //v[0].offsetTop
        }
        //this.fixTop = v[0].getBoundingClientRect().top + 344 //v[0].offsetTop
      }, 500)
      this.$forceUpdate()
    },
    //点击页面配置按钮，创建相应模块，打开相应模块设置窗口
    showSettingChange(e) {
      // e == 1 为打开背景设置，e == 2 为打开图片模块设置，e == 3 为打开商品模块设置
      this.showSettingBox = e;
      if (e == '1') return //背景设置

      // 图片模块、商品模块设置
      //关闭其它布局模块的遮罩
      this.viewData.forEach(item => {
        item.showViewMask = false;
        item.showViewMask2 = false;
      })
      //viewData为页面布局数据
      let viewData = {
        typeFlag: 1,//typeFlag = 1 为图片模块，2为商品模块
        showViewMask: true,
        showViewMask2: true
      }

      if (e == '2') {
        let imageModelInfo = {//图片模块
          img: '',//图片
          bindingType: '1',//有无绑定 1无绑定，2绑定标签，3绑定链接
          tagList: [],//绑定的标签
          url: '',//绑定的链接
        }
        viewData.typeFlag = 1;
        viewData.imageModelInfo = imageModelInfo;
        this.viewData.push(viewData)

        setTimeout(() => {
          let v = this.$refs['viewModul' + (this.viewData.length - 1)]
          this.fixTop = v[0].offsetTop
          console.log(v[0].offsetTop)
        }, 500)

      } else if (e == '3') {
        // thisPOstiin
        let goodsModelInfo = {
          bindingType: '1',//1为绑定标签，2为绑定商品
          tagList: [],//绑定的商品标签
          moreBtnType: '1',//1为文字名称，2为上传图片
          moreName: '', //按钮文字
          moreImg: '', //按钮图片
          moreHrefType: '1',//1为绑定标签，2为绑定链接
          btnTagList: [],//按钮的标签
          moreUrl: '',//按钮链接
          layoutType: '2',//1为三图平铺，2为双图排列
          borderType: '1',//1为无边框，2为有边框，3为边框图片
          borderColor: '', //边框颜色
          borderImg: '',//边框图片
          goodsList: []//商品列表
        }
        viewData.typeFlag = 2;
        viewData.goodsModelInfo = goodsModelInfo;
        this.viewData.push(viewData)
        setTimeout(() => {
          let v = this.$refs['viewModul' + (this.viewData.length - 1)]
          this.fixTop = v[0].offsetTop
          console.log(v[0].offsetTop)
        }, 500)
      }
      this.viewIndex = this.viewData.length - 1;
      console.log(this.viewIndex, this.viewData)
      // if(e == this.showSettingBox){
      //     this.showSettingBox = ''
      // }else{

      // }
    },
    onSizeChange(e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange(e) {
      this.labelPageNo = e;
      this.getTagList()
    },

    onGoodsSizeChange(e) {
      this.goodsPageSize = e;
      this.getGoodsList()
    },
    onGoodsCurrentChange(e) {
      this.goodsPageNo = e;
      this.getGoodsList()
    },
    //获取边框图片
    getborderImg(url) {
      this.viewData[this.viewIndex].goodsModelInfo.borderImg = this.ImgHttps + url
      console.log(this.ImgHttps + url)
    },
    //获取设置的背景图
    getBgImage(url) {
      this.pageBasic.bgImg = this.ImgHttps + url
      console.log(this.ImgHttps + url)
    },
    //删除背景图
    removeBgImage(url) {
      this.pageBasic.bgImg = ''
    },
    //按钮图片
    getmoreImg(url) {
      this.viewData[this.viewIndex].goodsModelInfo.moreImg = this.ImgHttps + url
    },
    //入口图片
    getBasicImg(url) {
      this.pageBasic.img = this.ImgHttps + url
    },
    getBasicImg1(url) {
      this.pageBasic.shareImg = this.ImgHttps + url
    },
    //图片模块上传的图片
    async getPictureImg(url) {
      this.viewData[this.viewIndex].imageModelInfo.img = this.ImgHttps + url
    },
    // 获取图片尺寸
    getImgSize(url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image()
        imgObj.src = url
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height
          })
        }
      })
    },
    closeFn() {

      this.fetchTagData('reset')
    },
    fetchTagData(type) {
      this.labelPageNo = 1
      this.labelPageSize = 5
      if (type == 'reset') {
        this.$refs['tagForm'].resetFields()
        this.labelPageNo = 1
        this.labelPageSize = 5
        this.getTagList()
      } else {
        this.getTagList()
      }
    },
    fetchGoodsData(type) {
      this.goodsPageNo = 1
      this.goodsPageSize = 5
      if (type == 'reset') {
        this.$refs['searchGoods'].resetFields()
        this.goodsPageNo = 1
        this.goodsPageSize = 5
      } else {
        this.getGoodsList()
      }
    },
    //获取标签数据
    getTagList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize,
        status: 1
      }
      data = Object.assign(data, this.searchTag)
      this.$api.selectTagDataPage(data)
        .then(res => {
          console.log(res);
          res.data.list.forEach(item => {
            item.selected = false
          })
          let e = this.showTagType;//1为图片模块的，2为绑定商品模块的，3为绑定按钮的
          if (this.viewData.length > 0) {
            //1为添加图片模块的绑定标签
            if (e == 1) {
              // console.log('this.viewIndex=', this.viewIndex)
              if (this.viewData[this.viewIndex].imageModelInfo.tagList) {
                res.data.list.forEach((item, index) => {
                  this.viewData[this.viewIndex].imageModelInfo.tagList.forEach((v, i) => {
                    if (item.id == v.id) {
                      item.selected = true;
                    }
                  })
                })
              }

            } else if (e == 2) {
              if (this.viewData[this.viewIndex].goodsModelInfo.tagList) {
                res.data.list.forEach((item, index) => {
                  this.viewData[this.viewIndex].goodsModelInfo.tagList.forEach((v, i) => {
                    if (item.id == v.id) {
                      item.selected = true;
                    }
                  })
                })
              }

            } else if (e == 3) {
              if (this.viewData[this.viewIndex].goodsModelInfo.btnTagList) {
                res.data.list.forEach((item, index) => {
                  this.viewData[this.viewIndex].goodsModelInfo.btnTagList.forEach((v, i) => {
                    if (item.id == v.id) {
                      item.selected = true;
                    }
                  })
                })
              }

            }
          }
          this.tagList = res.data.list;
          this.labelTotalNum = res.data.totalNum;
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取商品数据
    getGoodsList() {
      let params = {
        pageNo: this.goodsPageNo,
        pageSize: this.goodsPageSize,
        resultType: '',
        orderBy: 0
      }
      params = Object.assign(params, this.searchGoods)
      this.axios.post('/goods/pageList', params)
        .then((res) => {
          if (res.code === 0) {
            res.data.list.forEach(e => {
              e.selected = false;
            })
            this.goodsList = res.data.list
            this.goodsTotalNum = res.data.totalNum
          } else {
            console.log('goodsPageList - 失败', type)
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    //数组去重
    arrDistinctByProp(arr, prop) {
      if (prop) {
        return arr.filter(function (item, index, self) {
          return self.findIndex(el => el[prop] == item[prop]) === index
        })
      } else {
        return Array.from(new Set(arr));
      }

    }
  }
}
</script>
  
<style scoped lang="scss">
.page-content {
  display: flex;
}

.phone-view {
  width: 375px;
  height: 812px;
  background-image: url(../../../assets/img_phone.png);
  background-size: cover;
  overflow: hidden;
}

.bottom-but {
  margin-top: 60px;
  margin-bottom: 40px;
  text-align: center;

  .el-button {
    width: 176px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button+.el-button {
    margin-left: 20px;
  }
}

.settingbox {
  padding: 0 30px;
  box-sizing: border-box;
}

.bg-setting {
  width: 560px;
  background-color: white;
  padding: 20px;
}

.custom {
  padding: 20px 24px;
  background-color: #ebf2ff;
  margin-top: 150px;
}

.view-title {
  text-align: center;
  font-size: 16px;
  color: black;
  font-weight: bold;
  margin-top: 56px;
  height: 24px;
  line-height: 24px;
  // background-color: 44;
}

.view-content {
  width: calc(100% - 2px);
  height: calc(100% - 92px);
  background-color: transparent;
  margin-top: 10px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 0 0 20px 20px;
  background-size: 100% 100%;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.view-content::-webkit-scrollbar {
  display: none;
}

.tag—table-box {
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  padding: 10px 0;
}

.tag-status {
  display: flex;
  align-items: center;
  // justify-content: center;
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
}

.labelbox {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;

  .labelitem {
    background-color: #f0f3fd;
    padding: 2px 20px;
    font-size: 14px;
    color: #4168e7;
    position: relative;
    margin-right: 20px;
    line-height: 24px;

    .labelicon {
      color: #4168e7;
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      right: -6px;
      top: -6px;
    }
  }
}

.view-picture {
  width: 100%;
  height: 220px;
  position: relative;
  cursor: move;
}

.view-picture-mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(235, 242, 255, 0.3);
  z-index: 111;
}

.view-bar {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 222;
}

.view-bar-btn {
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
}

.icon-down {
  width: 16px;
  height: 16px;
  margin-right: 2px;
}

.icon-rotate {
  transform: rotate(180deg);
}

.menu-bar {
  width: 100%;
  height: 32px;
  font-size: 12px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.menu-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-next {
  width: 12px;
  height: 12px;
  margin-left: 2px;
}

.icon-heng {
  width: 18px;
  height: 18px;
}

.goods-box-two {
  width: 100%;
}

.goods-box-two-three {
  padding: 15px;
  box-sizing: border-box;
}

.look-more {
  float: right;
  width: 80px;
  height: 24px;
  background: #ffffff;
  border-radius: 13px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  margin-right: 32px;
}

.goods-two {
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  justify-content: space-between;
}

.goods-box {
  width: 49%;
}

.goods-info-box {
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding-bottom: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.goods-img-box {
  width: 100%;
  height: 170px;
  position: relative;
  box-sizing: border-box;
  border-radius: 11px 11px 0 0;
}

.goods-img {
  width: 100%;
  height: 100%;
  border-radius: 11px 11px 0 0;
}

.goods-img-border {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.good-dec {
  padding: 6px;
  box-sizing: border-box;
}

.goods-title {
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.gift-tips {
  display: inline-block;
  width: 30px;
  height: 16px;
  background: #f63c56;
  border-radius: 2px;
  font-size: 10px;
  color: white;
  text-align: center;
  line-height: 16px;
}

.goods-tips-box {
  display: flex;
  align-items: center;
  color: #f63c56;
  font-size: 10px;
  margin-top: 10px;
}

.goods-tip-item {
  padding: 0 6px;
  border: 1px solid #f63c56;
  border-radius: 2px;
  margin-right: 6px;
}

.goods-price-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.goods-price {
  font-size: 16px;
  color: #f63c56;
}

.goods-saled {
  color: #999999;
  font-size: 12px;
}

.goods-three {
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  background-color: white;
  border: 1px solid #333333;
  border-radius: 8px;
}

.three-info-box {
  width: 90px;
  margin-right: 18px;
  margin-bottom: 18px;
}

.three-info-box:nth-child(3n) {
  margin-right: 0;
}

.three-img-box {
  width: 98px;
  height: 98px;
  position: relative;
  border-radius: 11px 11px 0 0;
}

.picture-img {
  width: 100%;
  height: auto;
  display: block;
}

.goods-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-goods-img {
  width: 72px;
  height: 56px;
}

.btn-img {
  width: 100%;
  height: auto;
  // float: right;
}

.border-style {
  border: 1px solid transparent;
}

.tag-menu-box {
  width: 100%;
  padding: 15px 0 15px 15px;
  box-sizing: border-box;
  overflow-x: auto;
  background-color: white;
  white-space: nowrap;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

.tag-menu-box::-webkit-scrollbar {
  display: none;
}

.tag-menu-item {
  padding: 2px 15px;
  border-radius: 14px;
  background-color: #f5f5f5;
  font-size: 12px;
  margin-right: 8px;
  display: inline-block;
}

.tag-menu-active {
  background-color: #f63c56;
  color: white;
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168e7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-mini {
  width: 68px;
  height: 32px;
  background: #e3edff;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168e7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}

.primary-plain {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168e7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}

.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}
</style>